type Handler<T> = (payload: T) => void

/** Emitted by ChartManager after any pane relayout (indicator pane
 *  added/removed, container resize, separator drag, y-axis width re-pin).
 *  Payload is `undefined`; listeners read geometry on the next frame. */
export const LAYOUT_CHANGED_EVENT = 'layout:changed'

export class EventBus {
  private handlers = new Map<string, Set<Handler<unknown>>>()

  on<T = unknown>(event: string, handler: Handler<T>): () => void {
    if (!this.handlers.has(event)) {
      this.handlers.set(event, new Set())
    }
    this.handlers.get(event)!.add(handler as Handler<unknown>)
    return () => this.off(event, handler)
  }

  off<T = unknown>(event: string, handler: Handler<T>): void {
    this.handlers.get(event)?.delete(handler as Handler<unknown>)
  }

  emit<T = unknown>(event: string, payload: T): void {
    this.handlers.get(event)?.forEach((h) => {
      try {
        h(payload)
      } catch (err) {
        console.error(`[EdgeChart] EventBus error in "${event}" handler:`, err)
      }
    })
  }

  clear(): void {
    this.handlers.clear()
  }
}
